import { arrayOf, boolOf, idOf, objectOf, optionalText, textOf } from '../../../shared/api/wire'
import type { CommonDeliverResult, CommonDeliveryReasons, CommonSearchItem, CommonSearchPage } from '../model/commonSearch'

/** Страница поиска для продажи (`SaleSearchPageDto` Platform): товар общего каталога и, если он есть в кассе, ключ его карточки. */
export function decodeCommonSearchPage(raw: unknown): CommonSearchPage {
  const data = objectOf(raw, 'поиск для продажи')
  return {
    items: arrayOf(data.items, 'items').map((entry, index): CommonSearchItem => {
      const item = objectOf(entry, `items[${index}]`)
      return {
        productId: idOf(item.productId, `items[${index}].productId`),
        name: textOf(item.name, `items[${index}].name`),
        sku: optionalText(item.sku, `items[${index}].sku`),
        matchedBarcode: optionalText(item.matchedBarcode, `items[${index}].matchedBarcode`),
        inCash: boolOf(item.inCash, `items[${index}].inCash`),
        cardKey: optionalText(item.cardKey, `items[${index}].cardKey`),
      }
    }),
    hasMore: boolOf(data.hasMore, 'hasMore'),
  }
}

/** Ход «Отправить в кассу сейчас» (`SyncCashDeliveryDto` службы синхронизации): задача, состояние строки, код и слова кассы дословно. */
export function decodeCommonDeliverResult(raw: unknown): CommonDeliverResult {
  const data = objectOf(raw, 'отправка в кассу')
  return {
    jobId: idOf(data.jobId, 'jobId'),
    state: textOf(data.state, 'state'),
    code: optionalText(data.errorCode, 'errorCode'),
    message: optionalText(data.message, 'message'),
  }
}

/** Почему товаров нет в кассе (`SyncCashDeliveryReasonsDto`): товар → слова дословно. */
export function decodeCommonDeliveryReasons(raw: unknown): CommonDeliveryReasons {
  const data = objectOf(raw, 'почему товара нет в кассе')
  return new Map(
    arrayOf(data.items, 'items').map((entry, index) => {
      const item = objectOf(entry, `items[${index}]`)
      return [idOf(item.productId, `items[${index}].productId`), textOf(item.message, `items[${index}].message`)] as const
    }),
  )
}
